import { Switch } from "antd-mobile"
import styled from "styled-components"

export const ScheduleConfigFormSectionWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`

export const ScheduleTitle = styled.div`
  font-size: 14px;
  font-weight: 700;
  line-height: 160%;
`

export const ScheduleConfigContent = styled.div<{ $isDisabled?: boolean }>`
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 0px 8px;
  opacity: ${({ $isDisabled }) => ($isDisabled ? 0.5 : 1)};
`

export const ScheduleConfigLabel = styled.p`
  margin: 0;
  font-size: 16px;
`

export const WeekDayOption = styled.div<{ $isSelected: boolean }>`
  width: 32px;
  height: 32px;
  flex-shrink: 0;
  border-radius: 17px;
  font-weight: 700;
  line-height: 160%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;

  border: ${({ $isSelected }) =>
    `1px solid ${
      $isSelected
        ? "var(--Primary_16, rgba(13, 163, 186, 0.16))"
        : "transparent"
    }`};

  background: ${({ $isSelected }) =>
    $isSelected
      ? "rgba(13, 163, 186, 0.08)"
      : "var(--Schemes-Surface-Container, #EBEDF0)"};
  color: ${({ $isSelected }) =>
    $isSelected
      ? "var(--Schemes-Primary-Container-Variant-2, #0FBDD4)"
      : "var(--Schemes-Outline, rgba(0, 38, 58, 0.32))"};
`

export const DateSelectWrapper = styled.div<{ $isActive: boolean }>`
  display: flex;
  padding: 4px 8px;
  align-items: center;
  gap: 4px;
  border-radius: 4px;
  background: var(--Schemes-Surface-Container, #ebedf0);
  cursor: pointer;
  min-width: 118px;
  border: 1px solid
    ${({ $isActive }) =>
      $isActive
        ? "var(--Schemes-Primary-Container, #4BD9DE)"
        : "transparent"};
`

export const DateSelectLabel = styled.span`
  font-size: 14px;
  font-weight: 400;
  line-height: 160%;
`

export const Placeholder = styled.span`
  opacity: 0.4;
`

export const CheckboxLabel = styled.label`
  color: var(--Schemes-On-Surface-Variant-2, #69757d);
`

export const StyledSwitch = styled(Switch)`
  .adm-switch-checkbox {
    background: var(--Schemes-Outline-Variant, rgba(0, 38, 58, 0.14));

    &::before {
      content: none;
    }
  }
`
